import React from 'react';
import { Dataset } from '@calico/calico-ui-editorial';

import Datasets from '../content/Datasets.js';

const DownloadsPage = ({ className, style, trackDownload }) => {
  return (
    <div className={className} style={style}>
      <section className="article content-width">
        <div className="max-line-length margin-bottom-5">
          <h4>Datasets</h4>
          <p>Here we provide alternative forms of raw and derived data, in order for researchers to further investigate our findings or extend this work.</p>
        </div>
        {Datasets.map((dataset, d) => {
          return (
            <Dataset
              content={dataset.content}
              format={dataset.format}
              key={d}
              name={dataset.name}
              onDownload={trackDownload}
              size={dataset.size}
              src={dataset.src}
              title={dataset.title}
            />
          );
        })}
      </section>
    </div>
  );
}

export default DownloadsPage;
